import React, { useState, useEffect } from "react";
import axios from "axios";
import apiUrl from "../../Environment/Api";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Invoiceadd() {
  const navigate = useNavigate();
  const [exchangeRate, setExchangeRate] = useState("");
  const [currentDate, setCurrentDate] = useState(getFormattedDate());
  const [getinvoiceno, setinvoiceno] = useState("");
  const [isManualInvoice, setIsManualInvoice] = useState(false);
  const formatdateinvoice = new Date(currentDate);
  const [getinvoicejustno, setinvoicejustno] = useState("");

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [taskData, setTaskData] = useState([]);
  const [isGenerating, setIsGenerating] = useState(false);

  const [visibleColumns, setVisibleColumns] = useState([]);
  const [columnNames, setColumnNames] = useState({
    standard: "Standard",
    premier: "Premier",
    twilight: "Twilight",
    day_to_dusk: "Day to Dusk",
    vra: "VRA",
    vr: "VR",
    col7: "Column 7",
    col8: "Column 8",
    col9: "Column 9",
    col10: "Column 10",
    col11: "Column 11",
    col12: "Column 12",
  });

  const [showModal, setShowModal] = useState(false);
  const [pendingColumnKey, setPendingColumnKey] = useState(null);
  const [modalColumnName, setModalColumnName] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);

  useEffect(() => {
    clientdetails();
    invoiceno();
    categorytype();

    const fetchExchangeRate = async () => {
      const today = new Date().toISOString().split("T")[0];
      try {
        let response = await fetch(
          `https://api.frankfurter.dev/v1/${today}?base=USD&symbols=INR`,
        );
        if (!response.ok) {
          response = await fetch(
            "https://api.frankfurter.dev/v1/latest?base=USD&symbols=INR",
          );
        }
        const data = await response.json();
        if (data?.rates?.INR) {
          setExchangeRate(data.rates.INR);
        }
      } catch (error) {
        console.error("Error fetching exchange rate:", error);
      }
    };
    fetchExchangeRate();
  }, []);

  const [selectedClient, setSelectedClient] = useState("");
  const [tableData, setTableData] = useState([]);
  const [subtotal, setSubtotal] = useState(0);
  const [tax, setTax] = useState(0);
  const [netTotal, setNetTotal] = useState(0);
  const [clientRowCreated, setClientRowCreated] = useState(false);

  const [getclientaddress, setclientaddress] = useState("");
  const [getclientcountry, setclientcountry] = useState("");
  const [getclientName, setclientName] = useState("");
  const [getclientmobile, setclientmobile] = useState("");

  const [clientRate, setClientRate] = useState([]);

  const fetchClientRate = async () => {
    try {
      const response = await axios.get(`${apiUrl}/clientrate`);
      setClientRate(response.data || []);
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    fetchClientRate();
  }, []);

  const TASK_COLUMN_MAP = {
    standard: "standard",
    premier: "premier",
    twilight: "twilight",
    dtd: "day_to_dusk",
    vra: "vra",
    vr: "vr",
  };

  const TASK_COLUMN_LABELS = {
    standard: "Standard",
    premier: "Premier",
    twilight: "Twilight",
    dtd: "Day to Dusk",
    vra: "VRA",
    vr: "VR",
  };

  const columnOrder = [
    "standard",
    "premier",
    "twilight",
    "day_to_dusk",
    "vra",
    "vr",
    "col7",
    "col8",
    "col9",
    "col10",
    "col11",
    "col12",
  ];

  const handleGenerate = async () => {
    if (!fromDate || !toDate) {
      toast.error("Please select both From Date and To Date", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
      });
      return;
    }
    if (!selectedClient) {
      toast.error("Please select a Client before generating", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
      });
      return;
    }
    if (new Date(fromDate) > new Date(toDate)) {
      toast.error("From Date cannot be after To Date", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
      });
      return;
    }

    setIsGenerating(true);
    try {
      const response = await axios.get(`${apiUrl}/taskmanagement`);
      const allTasks = response.data;

      const selectedClientData = ClientDetails.find(
        (c) => c.id === parseInt(selectedClient, 10),
      );
      const selectedClientName = selectedClientData?.clientName
        ?.toLowerCase()
        .trim();

      const from = new Date(fromDate);
      from.setHours(0, 0, 0, 0);
      const to = new Date(toDate);
      to.setHours(23, 59, 59, 999);

      const filtered = allTasks.filter((task) => {
        const cd = task.client_details?.find(
          (c) => c.client_name?.toLowerCase().trim() === selectedClientName,
        );
        if (!cd) return false;
        const clientDate = new Date(cd.date); // uses "2026-04-24" from client_details
        return clientDate >= from && clientDate <= to;
      });

      if (filtered.length === 0) {
        toast.info("No tasks found for the selected client and date range.", {
          position: "top-right",
          autoClose: 3000,
        });
        setTableData([]);
        setIsGenerating(false);
        return;
      }

      setTaskData(filtered);

      const columnsWithData = new Set();
      filtered.forEach((task) => {
        const cd = task.client_details.find(
          (c) => c.client_name?.toLowerCase().trim() === selectedClientName,
        );
        if (cd) {
          Object.keys(TASK_COLUMN_MAP).forEach((apiKey) => {
            const val = cd[apiKey];
            if (val && val !== 0 && val !== "0" && val !== "") {
              columnsWithData.add(TASK_COLUMN_MAP[apiKey]);
            }
          });
        }
      });

      const autoColumns = columnOrder.filter((col) => columnsWithData.has(col));
      setVisibleColumns((prev) => [...new Set([...prev, ...autoColumns])]);

      const newColumnNames = { ...columnNames };
      Object.keys(TASK_COLUMN_MAP).forEach((apiKey) => {
        const colKey = TASK_COLUMN_MAP[apiKey];
        if (columnsWithData.has(colKey)) {
          newColumnNames[colKey] = TASK_COLUMN_LABELS[apiKey];
        }
      });
      setColumnNames(newColumnNames);

      // const newRows = filtered.map((task) => {
      //   const cd = task.client_details.find(
      //     (c) => c.client_name?.toLowerCase().trim() === selectedClientName,
      //   );
      //   const safeVal = (v) => (v && v !== 0 && v !== "0" ? String(v) : "");
      //   return {
      //     id: task.id,
      //     date: task.date ? task.date.split("T")[0] : getFormattedDate(),
      //     // projectName: cd?.client_address || "",
      //     projectName: cd?.address || "",
      //     editor_id: task.editor_id || "",
      //     editor_name: task.editor_name || "",
      //     standard: safeVal(cd?.standard),
      //     premier: safeVal(cd?.premier),
      //     twilight: safeVal(cd?.twilight),
      //     day_to_dusk: safeVal(cd?.dtd),
      //     vra: safeVal(cd?.vra),
      //     vr: safeVal(cd?.vr),
      //     col7: "",
      //     col8: "",
      //     col9: "",
      //     col10: "",
      //     col11: "",
      //     col12: "",
      //     type: "",
      //     quantity: 1,
      //     price: 0,
      //     tax: "",
      //     amount: "",
      //     rate: "",
      //   };
      // });

      const newRows = filtered.map((task) => {
        const cd = task.client_details.find(
          (c) => c.client_name?.toLowerCase().trim() === selectedClientName,
        );

        const safeVal = (v) => (v && v !== 0 && v !== "0" ? String(v) : "");

        // client rate getter
        const getRateValue = (typeName) => {
          const selectedClientData = ClientDetails.find(
            (c) => c.id === parseInt(selectedClient, 10),
          );

          if (!selectedClientData) return "";

          const typeData = clientRate.find(
            (item) =>
              item.type_name?.toLowerCase().trim() ===
              typeName.toLowerCase().trim(),
          );

          if (!typeData) return "";

          const clientData = typeData.client_data.find(
            (c) => c.client_id === selectedClientData.client_id,
          );

          return clientData?.value || "";
        };

        // CALCULATE TOTAL RATE
        const standardTotal =
          (parseFloat(cd?.standard) || 0) *
          (parseFloat(getRateValue("Standard")) || 0);

        const premierTotal =
          (parseFloat(cd?.premier) || 0) *
          (parseFloat(getRateValue("Premier")) || 0);

        const twilightTotal =
          (parseFloat(cd?.twilight) || 0) *
          (parseFloat(getRateValue("Twilight")) || 0);

        const dtdTotal =
          (parseFloat(cd?.dtd) || 0) *
          (parseFloat(getRateValue("Day To Dusk")) || 0);

        const vraTotal =
          (parseFloat(cd?.vra) || 0) * (parseFloat(getRateValue("Vra")) || 0);

        const vrTotal =
          (parseFloat(cd?.vr) || 0) * (parseFloat(getRateValue("Vr")) || 0);

        const finalRate =
          standardTotal +
          premierTotal +
          twilightTotal +
          dtdTotal +
          vraTotal +
          vrTotal;

        const finalPrice = finalRate * (parseFloat(exchangeRate) || 0);

        return {
          id: task.id,
          date: task.date ? task.date.split("T")[0] : getFormattedDate(),

          projectName: cd?.address || "",

          editor_id: task.editor_id || "",
          editor_name: task.editor_name || "",

          // LEFT INPUT VALUES
          standard: safeVal(cd?.standard),
          premier: safeVal(cd?.premier),
          twilight: safeVal(cd?.twilight),
          day_to_dusk: safeVal(cd?.dtd),
          vra: safeVal(cd?.vra),
          vr: safeVal(cd?.vr),

          // RIGHT INPUT VALUES
          standard_rate: getRateValue("Standard"),
          premier_rate: getRateValue("Premier"),
          twilight_rate: getRateValue("Twilight"),
          day_to_dusk_rate: getRateValue("Day To Dusk"),
          vra_rate: getRateValue("Vra"),
          vr_rate: getRateValue("Vr"),

          col7: "",
          col8: "",
          col9: "",
          col10: "",
          col11: "",
          col12: "",

          type: "",
          quantity: 1,
          price: finalPrice.toFixed(2),
          tax: "",
          amount: "",
          rate: finalRate.toFixed(2),
        };
      });

      setTableData(newRows);
      setClientRowCreated(true);
    } catch (err) {
      console.error("Error fetching task data:", err);
      toast.error("Failed to fetch task data. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
      });
    } finally {
      setIsGenerating(false);
    }
  };

  const handleAddColumn = () => {
    const availableColumns = columnOrder.filter(
      (col) => !visibleColumns.includes(col),
    );
    if (availableColumns.length > 0) {
      const nextColumnKey = availableColumns[0];
      setPendingColumnKey(nextColumnKey);
      setModalColumnName(columnNames[nextColumnKey]);
      setIsEditMode(false);
      setShowModal(true);
    }
  };

  const handleEditColumn = (columnKey) => {
    setPendingColumnKey(columnKey);
    setModalColumnName(columnNames[columnKey]);
    setIsEditMode(true);
    setShowModal(true);
  };

  const handleRemoveColumn = (columnKey) => {
    setVisibleColumns(visibleColumns.filter((col) => col !== columnKey));
    const updatedTableData = tableData.map((row) => ({
      ...row,
      [columnKey]: "",
    }));
    setTableData(updatedTableData);
  };

  const handleModalSave = () => {
    if (modalColumnName.trim() !== "" && pendingColumnKey) {
      setColumnNames({ ...columnNames, [pendingColumnKey]: modalColumnName });
      if (!isEditMode) {
        setVisibleColumns([...visibleColumns, pendingColumnKey]);
      }
      setShowModal(false);
      setModalColumnName("");
      setPendingColumnKey(null);
      setIsEditMode(false);
    } else {
      toast("Please enter a column name");
    }
  };

  const handleModalCancel = () => {
    setShowModal(false);
    setModalColumnName("");
    setPendingColumnKey(null);
    setIsEditMode(false);
  };

  const handleAddRow = () => {
    const newId = Date.now();
    const newRow = {
      id: newId,
      date: getFormattedDate(),
      projectName: "",
      editor_id: "",
      editor_name: "",
      standard: "",
      premier: "",
      twilight: "",
      day_to_dusk: "",
      vra: "",
      vr: "",
      col7: "",
      col8: "",
      col9: "",
      col10: "",
      col11: "",
      col12: "",
      type: "",
      quantity: 1,
      price: 0,
      tax: "",
      amount: "",
      rate: "",
    };
    setTableData([...tableData, newRow]);
    setClientRowCreated(true);
  };

  const handleClientChange = async (event) => {
    const clientValue = event.target.value;
    setSelectedClient(clientValue);

    const clientaddresscountryfilter = ClientDetails.filter(
      (data) => data.id === parseInt(clientValue, 10),
    );
    if (clientaddresscountryfilter.length > 0) {
      setclientName(clientaddresscountryfilter[0].clientName);
      setclientaddress(clientaddresscountryfilter[0].address);
      setclientcountry(clientaddresscountryfilter[0].countrycode);
      setclientmobile(clientaddresscountryfilter[0].mobile);
    }

    if (!clientRowCreated && clientValue !== "") {
      const newId = Date.now();
      setTableData([
        {
          id: newId,
          date: getFormattedDate(),
          projectName: "",
          editor_id: "",
          editor_name: "",
          standard: "",
          premier: "",
          twilight: "",
          day_to_dusk: "",
          vra: "",
          vr: "",
          col7: "",
          col8: "",
          col9: "",
          col10: "",
          col11: "",
          col12: "",
          type: "",
          quantity: 1,
          price: 0,
          tax: "",
          amount: "",
          rate: "",
        },
      ]);
      setClientRowCreated(true);
    } else {
      setClientRowCreated(false);
    }
  };

  // const handleUserInputChange = (index, property, value) => {
  //   const updatedTableData = [...tableData];
  //   updatedTableData[index] = { ...updatedTableData[index], [property]: value };
  //   if (property === "rate") {
  //     const rate = parseFloat(value) || 0;
  //     updatedTableData[index].price = (
  //       rate * (parseFloat(exchangeRate) || 83)
  //     ).toFixed(2);
  //   }
  //   setTableData(updatedTableData);
  // };

  // ── Totals — price is already in INR (rate × exchangeRate) ───────────────
  // useEffect(() => {
  //   let newSubtotal = 0;
  //   let newTax = 0;
  //   tableData.forEach((item) => {
  //     const quantity = parseFloat(item.quantity) || 0;
  //     const price = parseFloat(item.price) || 0;
  //     const taxPercent = parseFloat(item.tax) || 0;
  //     const baseAmount = price * quantity;
  //     const taxAmount = (baseAmount * taxPercent) / 100;
  //     newSubtotal += baseAmount;
  //     newTax += taxAmount;
  //   });
  //   setSubtotal(newSubtotal);
  //   setTax(newTax);
  //   setNetTotal(newSubtotal + newTax);
  // }, [tableData]);

  //   const handleUserInputChange = (index, property, value) => {
  //   const updatedTableData = [...tableData];

  //   updatedTableData[index] = {
  //     ...updatedTableData[index],
  //     [property]: value,
  //   };

  //   // AUTO RATE CALCULATION
  //   const row = updatedTableData[index];

  //   const getAmount = (qtyKey, rateKey) => {
  //     const qty = parseFloat(row[qtyKey]) || 0;
  //     const rate = parseFloat(row[rateKey]) || 0;
  //     return qty * rate;
  //   };

  //   const totalRate =
  //     getAmount("standard", "standard_rate") +
  //     getAmount("premier", "premier_rate") +
  //     getAmount("twilight", "twilight_rate") +
  //     getAmount("day_to_dusk", "day_to_dusk_rate") +
  //     getAmount("vra", "vra_rate") +
  //     getAmount("vr", "vr_rate");

  //   // STORE IN RATE FIELD
  //   row.rate = totalRate.toFixed(2);

  //   // EXISTING PRICE LOGIC
  //   const rate = parseFloat(row.rate) || 0;

  //   row.price = (
  //     rate * (parseFloat(exchangeRate) || 83)
  //   ).toFixed(2);

  //   setTableData(updatedTableData);
  // };

  const handleUserInputChange = (index, property, value) => {
    const updatedTableData = [...tableData];

    // UPDATE CURRENT FIELD
    updatedTableData[index] = {
      ...updatedTableData[index],
      [property]: value,
    };

    const row = updatedTableData[index];

    // SAFE MULTIPLY FUNCTION
    const multiplyValues = (leftValue, rightValue) => {
      const qty = parseFloat(leftValue) || 0;
      const rate = parseFloat(rightValue) || 0;

      return qty * rate;
    };

    // COLUMN WISE TOTALS
    const standardTotal = multiplyValues(row.standard, row.standard_rate);

    const premierTotal = multiplyValues(row.premier, row.premier_rate);

    const twilightTotal = multiplyValues(row.twilight, row.twilight_rate);

    const dtdTotal = multiplyValues(row.day_to_dusk, row.day_to_dusk_rate);

    const vraTotal = multiplyValues(row.vra, row.vra_rate);

    const vrTotal = multiplyValues(row.vr, row.vr_rate);

    // FINAL TOTAL
    const totalRate =
      standardTotal +
      premierTotal +
      twilightTotal +
      dtdTotal +
      vraTotal +
      vrTotal;

    // STORE RATE
    updatedTableData[index].rate = totalRate.toFixed(2);

    // PRICE CALCULATION
    const exchange = parseFloat(exchangeRate) || 0;

    updatedTableData[index].price = (totalRate * exchange).toFixed(2);

    setTableData(updatedTableData);
  };

  useEffect(() => {
    let newSubtotal = 0;
    let newTax = 0;

    const isIndia = getclientcountry === "91";

    tableData.forEach((item) => {
      const quantity = parseFloat(item.quantity) || 0;
      const taxPercent = parseFloat(item.tax) || 0;

      if (isIndia) {
        // Existing logic (₹ price)
        const price = parseFloat(item.price) || 0;
        const baseAmount = price * quantity;
        const taxAmount = (baseAmount * taxPercent) / 100;

        newSubtotal += baseAmount;
        newTax += taxAmount;
      } else {
        // NEW logic (rate only)
        const rate = parseFloat(item.rate) || 0;
        const baseAmount = rate * quantity;
        const taxAmount = (baseAmount * taxPercent) / 100;

        newSubtotal += baseAmount;
        newTax += taxAmount;
      }
    });

    setSubtotal(newSubtotal);
    setTax(newTax);
    setNetTotal(newSubtotal + newTax);
  }, [tableData, getclientcountry]);

  const tablerowdelete = (ItemId) => {
    setTableData((prevItems) => prevItems.filter((item) => item.id !== ItemId));
  };

  const handleClearAll = () => {
    setTableData([]);
    setClientRowCreated(false);
    setFromDate("");
    setToDate("");
    setTaskData([]);
  };

  const handleback = () => navigate("/invoice");

  const [getCategoryType, setCategoryType] = useState([]);
  const categorytype = async () => {
    try {
      const response = await axios.get(apiUrl + "/category");
      if (response) setCategoryType(response.data);
    } catch (err) {
      console.log(err);
    }
  };

  const [ClientDetails, setClientDetails] = useState([]);
  const clientdetails = async () => {
    try {
      const response = await axios.get(apiUrl + "/clientdetailsfull");
      if (response) setClientDetails(response.data);
    } catch (error) {
      console.error("Error fetching client details:", error);
    }
  };

  const [getinvoicedatelabel, setinvoicedatelabel] = useState("");

  const invoiceno = async () => {
    try {
      const response = await axios.get(apiUrl + "/invoiceno");
      const updatedInvoiceJustNo = response.data.invoiceId;
      setinvoicejustno(updatedInvoiceJustNo);
      const formattedDate = `${formatdateinvoice.getFullYear().toString().slice(-2)}${(formatdateinvoice.getMonth() + 1).toString().padStart(2, "0")}`;
      setinvoicedatelabel(formattedDate);
      if (!isManualInvoice) {
        setinvoiceno(`CLK${formattedDate}-${updatedInvoiceJustNo}`);
      }
    } catch (err) {
      console.log(err);
    }
  };

  function getFormattedDate() {
    const today = new Date();
    const year = today.getFullYear();
    let month = today.getMonth() + 1;
    let day = today.getDate();
    month = month < 10 ? `0${month}` : month;
    day = day < 10 ? `0${day}` : day;
    return `${year}-${month}-${day}`;
  }

  const validateForm = () => {
    const emptyFields = [];
    if (selectedClient === "") emptyFields.push("Client Name");
    if (currentDate === "") emptyFields.push("Date");
    if (getData.dueDate === "") emptyFields.push("Due Date");
    if (tax === "") emptyFields.push("Tax");

    if (emptyFields.length > 0) {
      toast.error(
        `Please fill in the following required fields: ${emptyFields.join(", ")}`,
        { position: "top-right", autoClose: 3000, theme: "colored" },
      );
      return false;
    }
    return true;
  };

  const [isDataSubmitted, setIsDataSubmitted] = useState(false);
  const [getData, setData] = useState({
    invoiceId: "",
    clientName: "",
    date: "",
    dueDate: "",
    notes: "",
    totalTax: "",
    paymentStatus: "Unpaid",
    totalAmount: "",
    paymentDate: "",
    getinvoicedatelabel: "",
  });
  const [storedNetTotal, setStoredNetTotal] = useState(0);

  // FIX: price is already rate × exchangeRate → no second multiply
  useEffect(() => {
    setStoredNetTotal(netTotal);
  }, [netTotal]);

  const toaster = (callback) => {
    toast.success("Data submitted successfully!", {
      autoClose: 1000,
      hideProgressBar: true,
      onClose: callback,
    });
  };

  const submitdata = async () => {
    const isValid = validateForm();
    if (!isDataSubmitted && isValid) {
      try {
        setIsDataSubmitted(true);

        const filteredTableData = tableData.filter(
          (item) => item.projectName && item.projectName.trim() !== "",
        );

        const selectedClientData = ClientDetails.find(
          (c) => c.id === parseInt(selectedClient, 10),
        );

        const payload = {
          invoiceHeader: {
            invoiceId: getinvoiceno,
            date: currentDate,
            dueDate: getData.dueDate,
            notes: getData.notes || "",
            totalTax: tax.toFixed(2),
            totalAmount: netTotal.toFixed(2),
            paymentStatus: "Unpaid",
          },
          clientdetails: {
            clientId: selectedClient,
            clientName: selectedClientData?.clientName || "",
            address: getclientaddress,
            country: getclientcountry,
            mobile: getclientmobile,
          },
          // editordetails: filteredTableData.map((item) => ({
          //   editor_id: item.editor_id || "",
          //   editor_name: item.editor_name || "",
          //   date: item.date,
          //   projectName: item.projectName,
          //   type: item.type || "",
          //   standard: item.standard || "",
          //   premier: item.premier || "",
          //   twilight: item.twilight || "",
          //   day_to_dusk: item.day_to_dusk || "",
          //   vra: item.vra || "",
          //   vr: item.vr || "",
          //   col7: item.col7 || "",
          //   col8: item.col8 || "",
          //   col9: item.col9 || "",
          //   col10: item.col10 || "",
          //   col11: item.col11 || "",
          //   col12: item.col12 || "",
          //   rate: item.rate || "",
          //   tax: item.tax || "",
          //   price: parseFloat(item.price) || 0,
          //   quantity: item.quantity || 1,
          //   amount: "",
          //   totalAmount: (
          //     parseFloat(item.quantity || 1) * parseFloat(item.price || 0) +
          //     (parseFloat(item.tax || 0) *
          //       parseFloat(item.quantity || 1) *
          //       parseFloat(item.price || 0)) /
          //       100
          //   ).toFixed(2),
          // })),

          editordetails: filteredTableData.map((item) => ({
            editor_id: item.editor_id || "",
            editor_name: item.editor_name || "",
            date: item.date,
            projectName: item.projectName,
            type: item.type || "",

            // LEFT INPUT VALUES
            standard: item.standard || "",
            premier: item.premier || "",
            twilight: item.twilight || "",
            day_to_dusk: item.day_to_dusk || "",
            vra: item.vra || "",
            vr: item.vr || "",

            // RIGHT INPUT VALUES
            standardrate:
              item.standard && item.standard !== "0"
                ? parseFloat(item.standard_rate || 0)
                : 0,

            premierrate:
              item.premier && item.premier !== "0"
                ? parseFloat(item.premier_rate || 0)
                : 0,

            twilightrate:
              item.twilight && item.twilight !== "0"
                ? parseFloat(item.twilight_rate || 0)
                : 0,

            dtdrate:
              item.day_to_dusk && item.day_to_dusk !== "0"
                ? parseFloat(item.day_to_dusk_rate || 0)
                : 0,

            vrarate:
              item.vra && item.vra !== "0" ? parseFloat(item.vra_rate || 0) : 0,

            vrrate:
              item.vr && item.vr !== "0" ? parseFloat(item.vr_rate || 0) : 0,

            // OTHER COLUMNS
            col7: item.col7 || "",
            col8: item.col8 || "",
            col9: item.col9 || "",
            col10: item.col10 || "",
            col11: item.col11 || "",
            col12: item.col12 || "",

            rate: item.rate || "",
            tax: item.tax || "",
            price: parseFloat(item.price) || 0,
            quantity: item.quantity || 1,
            amount: "",

            totalAmount: (
              parseFloat(item.quantity || 1) * parseFloat(item.price || 0) +
              (parseFloat(item.tax || 0) *
                parseFloat(item.quantity || 1) *
                parseFloat(item.price || 0)) /
                100
            ).toFixed(2),
          })),
        };

        const response = await axios.post(apiUrl + "/invoicelist", payload);

        if (response.data.status === "success") {
          // toaster(() => navigate("/invoice"));
          navigate(`/invoice/invoiceprint/${getinvoiceno}`);
        } else {
          setIsDataSubmitted(false);
        }
      } catch (err) {
        console.log("Error in submitdata:", err);
        setIsDataSubmitted(false);

        if (err.response && err.response.data) {
          const message = err.response.data.message || "";

          if (message.includes("duplicate") || message.includes("exists")) {
            toast.error("Invoice Id Already Created..!");
          } else {
            toast.error(message || "Something went wrong!");
          }
        } else {
          toast.error("Server not responding. Please try again!");
        }
      }
    }
  };

  const handlenavigate = async () => {
    const isValid = validateForm();
    if (isValid) {
      try {
        await submitdata();
        setTimeout(
          () => navigate(`/invoice/invoiceprint/${getinvoiceno}`),
          1000,
        );
      } catch (error) {
        console.error("Error submitting data and navigating:", error);
      }
    }
  };

  // Dynamic column count
  const hasEditorColumn = tableData.some((r) => r.editor_id || r.editor_name);

  let totalColumnsBeforeRate = 4 + visibleColumns.length;

  if (!hasEditorColumn) {
    totalColumnsBeforeRate -= 1;
  }

  // Totals
  const totalRate = tableData.reduce(
    (sum, item) => sum + (parseFloat(item.rate) || 0),
    0,
  );

  const totalPrice = tableData.reduce(
    (sum, item) => sum + (parseFloat(item.price) || 0),
    0,
  );

  // clientrate value
  const getClientRateValue = (columnKey) => {
    if (!selectedClient) return "";

    // selected client details
    const selectedClientData = ClientDetails.find(
      (c) => c.id === parseInt(selectedClient, 10),
    );

    if (!selectedClientData) return "";

    // column key -> type name mapping
    const typeNameMap = {
      standard: "Standard",
      premier: "Premier",
      twilight: "Twilight",
      day_to_dusk: "Day To Dusk",
      vra: "Vra",
      vr: "Vr",
    };

    const typeName = typeNameMap[columnKey];

    if (!typeName) return "";

    // find type
    const typeData = clientRate.find(
      (item) =>
        item.type_name?.toLowerCase().trim() === typeName.toLowerCase().trim(),
    );

    if (!typeData) return "";

    // find same client_id inside client_data
    const clientData = typeData.client_data.find(
      (c) => c.client_id === selectedClientData.client_id,
    );

    return clientData?.value || "";
  };

  return (
    <>
      <ToastContainer />

      {/* Column Name Modal */}
      {showModal && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {isEditMode ? "Edit Column Name" : "Name Your Column"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleModalCancel}
                ></button>
              </div>
              <div className="modal-body">
                <label className="form-label">Column Name:</label>
                <input
                  type="text"
                  className="form-control"
                  value={modalColumnName}
                  onChange={(e) => setModalColumnName(e.target.value)}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") handleModalSave();
                  }}
                  placeholder="Enter column name"
                  autoFocus
                />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleModalCancel}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleModalSave}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* <h3 className="text-center">Invoice</h3>
      <hr /> */}
      <div className="mx-1">
        {/* Row 1 – Invoice No & Date */}
        <div className="invoicebackground1">
          <form className="row align-items-center">
            <div className="col-lg-3 col-md-4 col-sm-12">
              <label className="form-label">Invoice No.</label>
              <input
                className="form-control"
                value={getinvoiceno}
                type="text"
                onChange={(e) => {
                  setinvoiceno(e.target.value);
                  setIsManualInvoice(true);
                }}
              />
            </div>
            <div className="col-lg-6 col-md-4">
              <h3 className="text-center">Add Invoice</h3>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-12">
              <label className="form-label">Date :</label>
              <input
                className="form-control"
                type="date"
                value={currentDate}
                onChange={(e) => setCurrentDate(e.target.value)}
                required
              />
            </div>
          </form>
        </div>

        {/* Row 2 – Client, From/To Date, Generate, Add Row, Add Column, Due Date */}
        <div className="invoicebackground1">
          <div className="row align-items-end g-2">
            <div className="col-lg-2 col-md-4 col-sm-12">
              <label className="form-label fw-semibold">Client Name :</label>
              <div className="position-relative">
                <select
                  className="form-select custom-select"
                  value={selectedClient}
                  onChange={handleClientChange}
                >
                  <option value="">Select an option</option>
                  {ClientDetails.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.clientName}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="col-lg-2 col-md-4 col-sm-12">
              <label className="form-label fw-semibold">From Date :</label>
              <input
                className="form-control"
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>

            <div className="col-lg-2 col-md-4 col-sm-12">
              <label className="form-label fw-semibold">To Date :</label>
              <input
                className="form-control"
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>

            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="d-flex flex-wrap gap-2 pb-1">
                <button
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={handleGenerate}
                  disabled={isGenerating}
                  style={{ whiteSpace: "nowrap" }}
                >
                  {isGenerating ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-1"
                        role="status"
                        aria-hidden="true"
                      />
                      Generating...
                    </>
                  ) : (
                    <>
                      <i className="fa-solid fa-bolt me-1"></i>Generate
                    </>
                  )}
                </button>

                <button
                  type="button"
                  className="btn btn-success btn-sm"
                  onClick={handleAddRow}
                  style={{ whiteSpace: "nowrap" }}
                >
                  <i className="fa-solid fa-plus me-1"></i>Add Row
                </button>

                {visibleColumns.length < 12 && (
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm"
                    onClick={handleAddColumn}
                    style={{ whiteSpace: "nowrap" }}
                  >
                    <i className="fa-solid fa-plus me-1"></i>Add Column
                  </button>
                )}
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-12">
              <label className="form-label fw-semibold">Due Date :</label>
              <input
                className="form-control"
                value={getData.dueDate}
                type="date"
                onChange={(e) =>
                  setData({ ...getData, dueDate: e.target.value })
                }
                required
              />
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="invoicebackground1">
          <div style={{ width: "100%", overflowX: "auto" }}>
            <table
              className="table table-bordered"
              style={{ minWidth: "1400px", tableLayout: "fixed" }}
            >
              <thead className="font-size">
                <tr>
                  <th style={{ width: "30px" }}>S.No</th>
                  <th style={{ width: "120px" }}>Date</th>
                  <th style={{ width: "120px" }}>Address</th>
                  {tableData.some((r) => r.editor_id || r.editor_name) && (
                    <>
                      <th style={{ width: "118px" }}>Editor Id / Name</th>
                    </>
                  )}
                  {/* {visibleColumns.map((colKey) => (
                    <th key={colKey} style={{ width: "90px" }}>
                      <div
                        className="d-flex align-items-center justify-content-between"
                        style={{ gap: "5px", overflow: "hidden" }}
                      >
                        <span
                          style={{
                            cursor: "pointer",
                            flex: 1,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                          onClick={() => handleEditColumn(colKey)}
                          title={columnNames[colKey]}
                        >
                          {columnNames[colKey]}
                        </span>
                        <i
                          className="fa-solid fa-edit"
                          style={{
                            fontSize: "12px",
                            cursor: "pointer",
                            flexShrink: 0,
                          }}
                          onClick={() => handleEditColumn(colKey)}
                          title="Edit column name"
                        ></i>
                        <i
                          className="fa-solid fa-trash text-danger"
                          style={{
                            fontSize: "12px",
                            cursor: "pointer",
                            flexShrink: 0,
                          }}
                          onClick={() => handleRemoveColumn(colKey)}
                          title="Remove column"
                        ></i>
                      </div>
                    </th>
                  ))} */}

                  {visibleColumns.map((colKey) => (
                    <th key={colKey} style={{ width: "90px" }}>
                      <div
                        className="d-flex align-items-center justify-content-between"
                        style={{ gap: "5px", overflow: "hidden" }}
                      >
                        <span
                          style={{
                            cursor: "pointer",
                            flex: 1,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                          onClick={() => handleEditColumn(colKey)}
                          title={columnNames[colKey]}
                        >
                          <div className="d-flex flex-column">
                            {/* COLUMN NAME */}
                            <span>{columnNames[colKey]}</span>

                            {/* CLIENT RATE */}
                            {getClientRateValue(colKey) && (
                              <small
                                style={{
                                  color: "#198754",
                                  fontSize: "13px",
                                  fontWeight: "600",
                                }}
                              >
                                ($ {getClientRateValue(colKey)})
                              </small>
                            )}
                          </div>
                        </span>

                        <i
                          className="fa-solid fa-edit"
                          style={{
                            fontSize: "12px",
                            cursor: "pointer",
                            flexShrink: 0,
                          }}
                          onClick={() => handleEditColumn(colKey)}
                          title="Edit column name"
                        ></i>

                        <i
                          className="fa-solid fa-trash text-danger"
                          style={{
                            fontSize: "12px",
                            cursor: "pointer",
                            flexShrink: 0,
                          }}
                          onClick={() => handleRemoveColumn(colKey)}
                          title="Remove column"
                        ></i>
                      </div>
                    </th>
                  ))}
                  <th style={{ width: "75px" }}>$ Rate</th>
                  <th style={{ width: "70px" }}>Tax %</th>
                  <th style={{ width: "70px" }}>₹ Price</th>
                  <th style={{ width: "60px" }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {tableData.map((item, index) => (
                  <tr key={item.id}>
                    <th scope="row">{index + 1}</th>
                    <td>
                      <input
                        style={{ width: "100%" }}
                        className="form-control pe-0"
                        type="date"
                        value={item.date}
                        onChange={(e) =>
                          handleUserInputChange(index, "date", e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <input
                        style={{ width: "100%" }}
                        className="form-control"
                        type="text"
                        value={item.projectName}
                        onChange={(e) =>
                          handleUserInputChange(
                            index,
                            "projectName",
                            e.target.value,
                          )
                        }
                      />
                    </td>
                    {/* {tableData.some((r) => r.editor_id || r.editor_name) && (
                      <>
                        <td>
                          <input
                            className="form-control"
                            type="text"
                            value={item.editor_id || ""}
                            onChange={(e) =>
                              handleUserInputChange(
                                index,
                                "editor_id",
                                e.target.value,
                              )
                            }
                          />
                        </td>
                        <td>
                          <input
                            className="form-control"
                            type="text"
                            value={item.editor_name || ""}
                            onChange={(e) =>
                              handleUserInputChange(
                                index,
                                "editor_name",
                                e.target.value,
                              )
                            }
                          />
                        </td>
                      </>
                    )} */}

                    {tableData.some((r) => r.editor_id || r.editor_name) && (
                      <td>
                        <input
                          className="form-control"
                          type="text"
                          value={`${item.editor_id || ""}${item.editor_id && item.editor_name ? " - " : ""}${item.editor_name || ""}`}
                          onChange={(e) => {
                            const value = e.target.value;

                            // Split "ID - Name"
                            const parts = value.split(" - ");
                            handleUserInputChange(
                              index,
                              "editor_id",
                              parts[0] || "",
                            );
                            handleUserInputChange(
                              index,
                              "editor_name",
                              parts[1] || "",
                            );
                          }}
                          placeholder="Editor ID - Name"
                        />
                      </td>
                    )}

                    {/* {visibleColumns.map((colKey) => (
                      <td key={colKey}>
                        <input
                          className="form-control"
                          type="text"
                          value={item[colKey]}
                          onChange={(e) =>
                            handleUserInputChange(index, colKey, e.target.value)
                          }
                        />
                      </td>
                    ))} */}

                    {visibleColumns.map((colKey) => (
                      <td key={colKey}>
                        <div className="d-flex gap-1">
                          {/* LEFT INPUT */}
                          <input
                            className="form-control form-control-sm"
                            type="text"
                            value={item[colKey] || ""}
                            onChange={(e) =>
                              handleUserInputChange(
                                index,
                                colKey,
                                e.target.value,
                              )
                            }
                          />

                          {/* RIGHT INPUT */}
                          <input
                            className="form-control form-control-sm"
                            type="text"
                            value={item[`${colKey}_rate`] || ""}
                            onChange={(e) =>
                              handleUserInputChange(
                                index,
                                `${colKey}_rate`,
                                e.target.value,
                              )
                            }
                          />
                        </div>
                      </td>
                    ))}

                    <td>
                      <input
                        className="form-control ps-2"
                        placeholder="rate"
                        value={item.rate}
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^0-9.]/g, "");
                          handleUserInputChange(index, "rate", value);
                        }}
                        readOnly
                      />
                    </td>
                    <td>
                      <input
                        className="form-control"
                        type="tel"
                        value={item.tax}
                        placeholder="Tax"
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^0-9]/g, "");
                          handleUserInputChange(index, "tax", value);
                        }}
                      />
                    </td>
                    <td>
                      <input
                        className="form-control"
                        type="text"
                        value={item.price || 0}
                        readOnly
                      />
                    </td>
                    <td>
                      <button
                        className="btn btn-danger px-1 py-1 d-flex align-items-center"
                        onClick={() => tablerowdelete(item.id)}
                      >
                        <i className="fa-solid fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot className="table -secondary">
                <tr>
                  {/* Dynamic span till RATE column */}
                  <td
                    colSpan={totalColumnsBeforeRate}
                    style={{ textAlign: "right" }}
                  >
                    <b>Total</b>
                  </td>

                  {/* $ Rate Total */}
                  <td>
                    <input
                      className="form-control fw-bold"
                      value={totalRate.toFixed(2)}
                      readOnly
                    />
                  </td>

                  {/* Tax column empty */}
                  <td></td>

                  {/* ₹ Price Total */}
                  <td colSpan={2}>
                    <input
                      className="form-control fw-bold"
                      value={totalPrice.toFixed(2)}
                      readOnly
                    />
                  </td>

                  {/* Action column empty */}
                  {/* <td></td> */}
                </tr>
              </tfoot>
            </table>
          </div>

          {/* Notes + Totals */}
          <div className="row mt-4">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <label className="form-label">
                <b>Notes :</b>
                <br />
                <textarea
                  className="form-control notes-textarea"
                  value={getData.notes}
                  onChange={(e) =>
                    setData({ ...getData, notes: e.target.value })
                  }
                  required
                />
              </label>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <form>
                <div className="row">
                  <div className="col-lg-5 col-md-6 mt-1">
                    <label className="form-label">
                      <b>Sub Total ({getclientcountry === "91" ? "₹" : "$"})</b>
                    </label>
                  </div>
                  <div className="col-lg-7 col-md-6">
                    <input
                      className="form-control"
                      value={
                        getclientcountry === "91"
                          ? `₹ ${subtotal.toFixed(2)}`
                          : `$ ${subtotal.toFixed(2)}`
                      }
                      type="text"
                      readOnly
                    />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-lg-5 col-md-6 mt-1">
                    <label className="form-label">
                      <b>
                        Paypal Tax ({getclientcountry === "91" ? "₹" : "$"})
                      </b>
                    </label>
                  </div>
                  <div className="col-lg-7 col-md-6">
                    <input
                      className="form-control"
                      value={
                        getclientcountry === "91"
                          ? `₹ ${tax.toFixed(2)}`
                          : `$ ${tax.toFixed(2)}`
                      }
                      type="text"
                      readOnly
                    />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-lg-5 col-md-6 mt-1">
                    <label className="form-label">
                      <b>Net Total ({getclientcountry === "91" ? "₹" : "$"})</b>
                    </label>
                  </div>
                  <div className="col-lg-7 col-md-6">
                    {/* FIX: use netTotal directly — price already includes exchangeRate */}
                    <input
                      className="form-control"
                      type="text"
                      value={
                        getclientcountry === "91"
                          ? `₹ ${Math.round(netTotal).toFixed(2)}`
                          : `$ ${Math.round(netTotal).toFixed(2)}`
                      }
                      readOnly
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>

          {/* Action buttons */}
          <div className="row">
            <div className="col-lg-5"></div>
            <div className="col-lg-7">
              <div
                style={{ marginLeft: "75px" }}
                className="d-flex justify-content-end gap-5 mt-3 buttonstyle"
              >
                <button
                  type="button"
                  className="btn btn-danger invoice-button"
                  onClick={handleClearAll}
                >
                  Clear
                </button>
                <button
                  type="button"
                  className="btn btn-info text-white invoice-button"
                  style={{ backgroundColor: "#007BFF" }}
                  onClick={handleback}
                >
                  Back
                </button>
                <button
                  type="button"
                  className="btn btn-success invoice-button"
                  onClick={submitdata}
                >
                  Save
                </button>
                {/* <button
                  type="button"
                  className="btn btn-secondary invoice-button"
                  onClick={handlenavigate}
                >
                  Print
                </button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Invoiceadd;
